<template>
  <label 
    class="sm-checkbox"
    :class="'sm-checkbox--' + type"
  >
    <input 
      type="checkbox"
      :checked="value"
      :name="name"
      @change="$emit('input', $event.target.checked)"
    >
    <span>{{text}}</span>
  </label>
</template>

<script>
export default {
  name: 'checkbox-block',
  props: {
    type: {
      type: String,
      default: 'base'
    },
    name: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    value: Boolean
  }
}
</script>